import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

interface Props {
    title: string;
    value: React.ReactNode; // Accept any valid React content
}

const ProgressSummaryCard: React.FC<Props> = ({ title, value }) => (
    <Card>
        <CardContent>
            <Typography variant="h6">{title}</Typography>
            <Box mt={1}>
                {typeof value === 'string' ? (
                    <Typography variant="h5" color="primary">
                        {value}
                    </Typography>
                ) : (
                    value // Render as-is if it's not a string
                )}
            </Box>
        </CardContent>
    </Card>
);

export default ProgressSummaryCard;
